<script>
import SuppliersApi from "@/services/suppliers-api";
export default {
    props: {
      isLaboratory:{
        type: Boolean,
        default:false
      },
      isProvider:{
        type: Boolean,
        default:false
      },
    },
  data() {
    return {
      search:null,
      suppliersList :[],
      pagemodelMain: {currentPage : 1, perPage : 50, totalRows: 0},
      isItemsTableBusy: false,
      endOfFindItems:false,
      type: null,
      showModal:null,
      selecteProvider:null,
      filesList:[],
      isFilesTableBusy:false,
      }
    },
    
  mounted() {
    this.getSuppliers();
  },

  methods: {
    getSuppliers() {
      this.isItemsTableBusy = true;
      if(this.isLaboratory) {
        this.type=0
      }
      if(this.isProvider) {
        this.type=1
      }
      SuppliersApi.getOnlyVisibleSuppliers(this.search,this.pagemodelMain.currentPage, this.pagemodelMain.perPage, this.type)
      .then(suppliersListDTO => {
        this.suppliersList = suppliersListDTO.list
        this.pagemodelMain.totalRows = suppliersListDTO.total;
        this.pagemodelMain.currentPage = suppliersListDTO.page;
        this.pagemodelMain.perPage = suppliersListDTO.pageSize;
        this.pagemodelMain.pageSize = suppliersListDTO.pageSize;
      })
      .finally(() => {
      this.isItemsTableBusy = false;
      this.endOfFindItems =true;
      })
    },
    exportPDF(fileGeneratedName,fileName){
      SuppliersApi.exportPDF(fileGeneratedName,fileName )
    },

    getProvidersFiles(selecteProvider){
      this.isFilesTableBusy=true
      SuppliersApi.getProvidersFiles(selecteProvider.id).then(
        result => {
          this.filesList = result;
          this.isFilesTableBusy=false

        }
      )
    }
}    
};
</script>
<template>
  <div class="table-responsive mt-3">
      <div class="row mb-4">
        <div class="col-sm-3" />
        <div class="col-sm-5 col-9">
            <b-form-input type="text" style="font-size: 14px;" :placeholder="isLaboratory ? 'Cherchez un fournisseur ...' : 'Cherchez un prestataire ...' " v-model="search" @keyup.native.enter="getSuppliers()"></b-form-input>
        </div>
        <div class="col-sm-1 col-1 ml-2">
          <b-button variant="success" @click="getSuppliers()"><i class="fas fa-search font-size-16 align-middle"></i></b-button>
        </div>
        <div class="col-sm-3" />
      </div>
      <table class="table project-list-table table-striped table-borderless table-centered " >
        <thead>
          <tr>
            <th  class="font-size-14 " style="width:70px">Logo</th>
            <th  class="font-size-14" style="width:350px"> {{ isLaboratory ? 'Fournisseur': 'Prestataire' }}</th>
            <!-- <th  class="font-size-16 text-center" style="width:70px;" v-if="isLaboratory">Offres</th> -->
            <th  class="font-size-14" style="width:50px; text-align: center;">{{isLaboratory ? 'Catalogue' : 'Details'}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="supplier in suppliersList" :key="supplier.id">
            <td v-if="isLaboratory" class="font-weight-bold">
              <router-link  :to="{ path: '/suppliers/catalog', query: { supplierId: supplier.id, isCashPaymentMandetory: supplier.isCashPaymentMandetory }}">
                <img v-bind:src="'/api/image/get/' + supplier.logo" alt class="avatar-sm" style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px;" />
              </router-link>
            </td>
            <td v-if="isProvider" @click="selecteProvider=supplier;getProvidersFiles(supplier);showModal=true" class="font-weight-bold" style="cursor:pointer">
                <img v-bind:src="'/api/image/get/' + supplier.logo" alt class="avatar-sm" style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px;" />
            </td>
            <td  v-if="isLaboratory" class="">   
              <router-link  :to="{ path: '/suppliers/catalog', query: { supplierId: supplier.id, isCashPaymentMandetory:supplier.isCashPaymentMandetory  }}" class="">
                <p class="mb-1 font-size-18 align-middle font-weight-bold text-dark">{{supplier.name}}</p>
                <!-- <p class="mb-0 text-muted font-size-12 d-none d-sm-block">{{supplier.address}}, {{supplier.city.name}}, {{supplier.country.name}}</p> -->
                <p class="font-size-16 align-middle font-weight-bold text-info" >{{supplier.note ? supplier.note : "_"}}</p>

              </router-link>    
      
            </td>
            <td  v-if="isProvider" @click="selecteProvider=supplier;getProvidersFiles(supplier);showModal=true" class="font-size-18 align-middle font-weight-bold" style="cursor:pointer">   
                <p class="mb-1 font-size-18 align-middle font-weight-bold">{{supplier.name}}</p>
                <p class="mb-0 text-muted font-size-12 d-none d-sm-block">{{supplier.address}}, {{supplier.city.name}}, {{supplier.country.name}}</p>
            </td>
            <!-- <td  v-if="isLaboratory"  class="font-size-18 align-middle text-center">
              <span class="text-danger font-weight-bold">{{supplier.offersCount}}</span>
            </td> -->
            <td v-if="isLaboratory" class="align-middle text-center">
              <router-link :to="{ path: '/suppliers/catalog', query: { supplierId: supplier.id, isCashPaymentMandetory:supplier.isCashPaymentMandetory  }}">
                <a href="javascript:void(0);"  class="font-size-24"><i v-b-tooltip.hover title="Catalogue" class="far fa-list-alt text-primary"></i></a>
              </router-link>
            </td>
            <td v-if="isProvider" @click="selecteProvider=supplier;getProvidersFiles(supplier);showModal=true" class="align-middle text-center" style="cursor:pointer">
                <a href="javascript:void(0);"  class="font-size-24"><i v-b-tooltip.hover title="Details" class="far fa-list-alt text-primary"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isItemsTableBusy" class="d-flex justify-content-center">
          <div class="spinner-border text-success" role="status">
              <span class=" sr-only">Loading...</span>
          </div>
      </div>
        <span  v-if="isLaboratory & !isItemsTableBusy & !suppliersList.length & endOfFindItems" class="d-flex justify-content-center" >Pas de fournisseurs dans le tableau </span>
        <span  v-if="isProvider & !isItemsTableBusy & !suppliersList.length & endOfFindItems" class="d-flex justify-content-center" >Pas de prestataires dans le tableau </span>

      <!-- Pagination -->
      <div class="row pt-3 mb-sm-4">
          <div class="col-sm-8">
              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                  <b-form-select @input="getSuppliers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
              </div>
          </div>
          <div class="col-sm-4">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                  <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getSuppliers()" ></b-pagination>
                  </ul>
              </div>
          </div>
      </div> 
      <!-- Fin Pagination  -->

    <!-- <b-modal v-if="this.selecteProvider"
      v-model="showModal" 
      hide-footer
      title="Details du prestataire" 
      centered 
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl"
      >

    <div class="row">
      <div class="col-lg-3 ">
        <b-card header-class="bg-transparent border-primary " class="border border-primary border-right-0 h-100">
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="fas fa-briefcase mr-3"></i>Details Generals
            </h5>
          </template>

          <div class="row pb-4">

            <div class="col-sm-8">
              <div class="row" >
                <span class="font-weight-bold  text-primary" style="font-size:1.8em;">{{selecteProvider.name}}</span>
              </div>

              <div class="row pt-2">
                <span class="text-muted font-size-14" >{{selecteProvider.address}}, {{selecteProvider.city.name}}, {{selecteProvider.country.name}}</span>
              </div>

              <div class="row pt-2">
                <span class="text-muted font-size-14"><strong><i class="fas fa-phone-square  mr-2" />{{selecteProvider.phone}}</strong></span> 
              </div>

              <div class="row">
                <span class="text-muted font-size-14"><strong><i class="far fa-envelope   mr-2" />{{selecteProvider.mail}}</strong></span>
              </div>   

            </div>

            <div class="col-sm-1"/>

            <div class="col-sm-3">
              
              <img v-bind:src="'/api/image/get/'+selecteProvider.logo" alt style=";width: 100%; ; margin: auto; display: block; ">
            </div>
            
          </div>
          
          <div class="card-footer bg-transparent border-top pb-4">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Site web" target="_blank" :href="selecteProvider.webSite">
                  <i class="fas fa-globe text-info"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Facebook" target="_blank" :href="selecteProvider.facebook">
                  <i class="fab fa-facebook-square text-info"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Instagram" target="_blank" :href="selecteProvider.instagram">
                  <i class="fab fa-instagram text-info"></i>
                </a>
              </div>
                
            </div>
          </div>

        </b-card>
        <b-card header-class="bg-transparent border-primary " class="border border-primary border-right-0 h-50">
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="far fa-user mr-3"></i>Représentants
            </h5>
          </template>
          <div  class="table-responsive mb-0" style="overflow-y:auto;">
                <ul v-for="contact in selecteProvider.contacts" :key="contact.id" >
                    <li class="pb-1 font-size-14">
                        <strong >{{contact.firstName}} {{contact.lastName}}</strong><br>
                        <i class="fas fa-phone-square mr-2" />{{contact.phone}} <br>
                        <i class="far fa-envelope   mr-2"/>{{contact.email}} 
                    </li>
                </ul>
          </div>
        </b-card>
      </div>
      <div class="col-lg-9 ">
        <b-card header-class="bg-transparent border-primary " class="border border-primary h-100" >
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="fas fa-paragraph mr-3"></i>Description de la societé
            </h5>
          </template>

            <span  v-html="selecteProvider.description" class="text-justify "> </span>
        </b-card>

        <b-card header-class="bg-transparent border-primary " class="border border-primary  h-50" >
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="fas fa-file mr-3"></i>Piéces jointes
            </h5>
          </template>
          <h5 class="card-title mt-0">card title</h5>
          <div class="row">
            <div v-for="file in filesList" :key="file.id">
              <b-button @click.prevent="exportPDF(file.id)"  size="lg" variant="outline-info" class="mr-2 mb-2" >
                <i class="fas fa-download font-size-16 align-middle mr-2"></i>{{file.name}}
              </b-button> 
            </div>
          </div>
        </b-card>
      </div>

    </div>
    </b-modal>  -->


    <b-modal v-if="this.selecteProvider"
      v-model="showModal" 
      title="Details du prestataire" 
      centered 
      hide-footer
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl"
      >

    <div class="row zoom-container ">
      <div class="col-lg-6 pr-sm-4 pb-4">
        <b-card header-class="bg-transparent border-primary " class="border border-primary  h-100">
          <div class="row pb-4">
            <div class="col-sm-8">
              <div class="row" >
                <span class="font-weight-bold  text-primary" style="font-size:1.8em;">{{selecteProvider.name}}</span>
              </div>
              <div class="row pt-2">
                <span class="text-muted font-size-14" >{{selecteProvider.address}}, {{selecteProvider.city.name}}, {{selecteProvider.country.name}}</span>
              </div>
              <div class="row pt-2">
                <span class="text-muted font-size-14"><strong><i class="fas fa-phone-square  mr-2" />{{selecteProvider.phone}}</strong></span> 
              </div>
              <div class="row">
                <span class="text-muted font-size-14"><strong><i class="far fa-envelope   mr-2" />{{selecteProvider.mail}}</strong></span>
              </div>   
            </div>
            <div class="col-sm-1"/>
            <div class="col-sm-3">
              <img v-bind:src="'/api/image/get/'+selecteProvider.logo" alt style=";width: 100%; ; margin: auto; display: block; ">
            </div>
          </div>
          <div class="card-footer bg-transparent border-top pb-4">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Site web" target="_blank" :href="selecteProvider.webSite">
                  <i class="fas fa-globe text-info"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Facebook" target="_blank" :href="selecteProvider.facebook">
                  <i class="fab fa-facebook-square text-info"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Instagram" target="_blank" :href="selecteProvider.instagram">
                  <i class="fab fa-instagram text-info"></i>
                </a>
              </div>
                
            </div>
          </div>

        </b-card>
      </div>
      <div class="col-lg-6 pb-4 ">
        <b-card header-class="bg-transparent border-primary " class="border border-primary  h-100" >
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="far fa-user mr-3"></i>Représentants
            </h5>
          </template>
          <div  class="table-responsive mb-0" style="overflow-y:auto;">
                <ul v-for="contact in selecteProvider.contacts" :key="contact.id" >
                    <li class="pb-1 font-size-14">
                        <strong >{{contact.firstName}} {{contact.lastName}}</strong><br>
                        <i class="fas fa-phone-square mr-2" />{{contact.phone}} <br>
                        <i class="far fa-envelope   mr-2"/>{{contact.email}} 
                    </li>
                </ul>
          </div>
        </b-card>
      </div>

    <div class="row  w-100">
      <div class="col-12 ">
        <b-card header-class="bg-transparent border-primary " class="border border-primary" >
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="fas fa-newspaper mr-3"></i>Presentation de la societé
            </h5>
          </template>
            <span v-html="selecteProvider.description" class="text-justify "> </span>
        </b-card>
      </div>
    </div>


    <div class="row pt-4 w-100">
      <div class="col-12 ">
        <b-card header-class="bg-transparent border-primary " class="border border-primary" >
          <template v-slot:header>
            <h5 class="my-0 text-primary">
              <i class="fas fa-file mr-3"></i>Piéces jointes
            </h5>
          </template>
          <div class="row">
            <div v-for="file in filesList" :key="file.id">
              <b-button @click.prevent="exportPDF(file.generatedName,file.name)"  size="lg" variant="outline-info" class="mr-2 mb-2" >
                <i class="fas fa-download font-size-16 align-middle mr-2"></i>{{file.name}}
              </b-button> 
            </div>
          </div>
          <div v-if="isFilesTableBusy" class="d-flex justify-content-center">
            <div class="spinner-border text-success" role="status">
              <span class=" sr-only">Loading...</span>
            </div>
          </div>

        </b-card>
      </div>
      </div>
    </div>
    </b-modal> 
  </div>
</template>